var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "container-item-wrapper",
    { attrs: { widget: _vm.widget } },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.widget.options.hidden,
              expression: "!widget.options.hidden",
            },
          ],
          key: _vm.widget.id,
          ref: _vm.widget.id,
          staticClass: "card-container",
          class: [!!_vm.widget.options.folded ? "folded" : "", _vm.customClass],
          style: {
            width: _vm.widget.options.cardWidth + "!important" || "",
            marginTop:
              _vm.widget.options.topMargin + 20 + "px !important" || "",
            marginBottom:
              _vm.widget.options.bottomMargin + "px !important" || "",
          },
          attrs: { shadow: _vm.widget.options.shadow },
        },
        [
          _vm.widget.options.cardHeader
            ? _c(
                "div",
                {
                  staticClass: "clear-fix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.widget.options.label)),
                  ]),
                  _vm._v(" "),
                  _vm.widget.options.showFold
                    ? _c("i", {
                        staticClass: "float-right",
                        class: [
                          !_vm.widget.options.folded
                            ? "el-icon-arrow-down"
                            : "el-icon-arrow-up",
                        ],
                        on: { click: _vm.toggleCard },
                      })
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !!_vm.widget.widgetList && _vm.widget.widgetList.length > 0
            ? [
                _vm._l(_vm.widget.widgetList, function (subWidget, swIdx) {
                  return [
                    "container" === subWidget.category
                      ? [
                          _c(_vm.getComponentByContainer(subWidget), {
                            key: swIdx,
                            tag: "component",
                            attrs: {
                              widget: subWidget,
                              "parent-list": _vm.widget.widgetList,
                              "index-of-parent-list": swIdx,
                              "parent-widget": _vm.widget,
                            },
                            scopedSlots: _vm._u(
                              [
                                _vm._l(
                                  Object.keys(_vm.$scopedSlots),
                                  function (slot) {
                                    return {
                                      key: slot,
                                      fn: function (scope) {
                                        return [_vm._t(slot, null, null, scope)]
                                      },
                                    }
                                  }
                                ),
                              ],
                              null,
                              true
                            ),
                          }),
                        ]
                      : [
                          _c(subWidget.type + "-widget", {
                            key: swIdx,
                            tag: "component",
                            attrs: {
                              field: subWidget,
                              designer: null,
                              "parent-list": _vm.widget.widgetList,
                              "index-of-parent-list": swIdx,
                              "parent-widget": _vm.widget,
                            },
                            scopedSlots: _vm._u(
                              [
                                _vm._l(
                                  Object.keys(_vm.$scopedSlots),
                                  function (slot) {
                                    return {
                                      key: slot,
                                      fn: function (scope) {
                                        return [_vm._t(slot, null, null, scope)]
                                      },
                                    }
                                  }
                                ),
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                  ]
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }